import {action, computed, observable} from "mobx";
import api from '../utils/api';

/**
 * Gerencia o envio de url qrcode
 */

class QrcodeStore {
    @observable status;
    @observable isLoading = false;
    @observable load = 1;
    @observable confirm = 2;
    @observable fail = 3;

    /**
     * Send QRcode url
     * @param url
     * @return {status}
     */
    @action
    async sendQrcode(url) {
        this.isLoading = true;

        let moment = require('moment');

        let date = moment().utc().format('YYYY-MM-DDThh:mm:ss');
        date = date + 'Z';

        let qrcode = {
            "url": url,
            "clientNow": date
        };

        return await api.call('qrcode/sendUrl', 'POST', qrcode)
            .then((json) => {
                this.isLoading = false;

                if (json && json.length > 0) {

                } else {

                }
            }).catch(error => {
                console.log(error);
                this.isLoading = false;
            });
    }
}

export default new QrcodeStore();


// WEBPACK FOOTER //
// ./src/stores/QrcodeStore.js